import { Form, Input } from "semantic-ui-react";
import { SharedAddressFieldProps } from "./AddressFormField";
import classNames from "classnames";
import { useId } from "react-aria";

interface SecondaryAddressFormFieldProps extends SharedAddressFieldProps {
  countryField?: React.ReactNode;
}

export function SecondaryAddressFormField({
  label = "Apt, Suite, Floor, Other",
  subLabel,
  value,
  disabled,
  error,
  labelClassName,
  transform,
  handleChange,
  countryField,
  isMobileLayout,
}: SecondaryAddressFormFieldProps) {
  const id = useId();
  return (
    <div
      className={classNames("tw-flex tw-min-w-0 tw-flex-1 tw-flex-grow", {
        "tw-gap-2": isMobileLayout,
        "tw-gap-4": !isMobileLayout,
      })}
    >
      <div className='tw-flex-grow-1 tw-w-full tw-min-w-0'>
        <Form.Field className='!tw-mb-0' disabled={disabled} error={!!error}>
          <label
            htmlFor={id}
            className={classNames("tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap", labelClassName)}
          >
            {label}
          </label>
          {subLabel && (
            <div
              className={classNames("sub-label", {
                "tw-text-[#b2b2b2]": disabled,
              })}
            >
              {subLabel}
            </div>
          )}
          <Input
            id={id}
            type='text'
            disabled={disabled}
            value={transform.input(value)?.address2 ?? ""}
            onChange={(_, { value }) => handleChange({ address2: value })}
            autoComplete='address-line2'
          />
        </Form.Field>
      </div>
      {countryField}
    </div>
  );
}
